import { useHasPermission } from "../../auth/useClaims";

// Branch-wise master (handoff §9.7/§13.3) - Customers.Create/.Edit are
// separate permissions a role can hold independently, unlike the global
// masters no all-branch check is needed here; the API already scopes every
// request to the caller's own branch(es) server-side. Covers the customer's
// own record only (contact/address/branch-link fields, PUT .../{custId}) and
// cross-branch linking (POST/DELETE .../link). Guard Assignments and Bulk
// Guards split off into their own Deployment.Edit permission (handoff §13.4) -
// see useGuardPermissions.js - a CRM role editing a customer's own record
// doesn't automatically get to deploy guards, and vice versa.
export const useCanCreateCustomers = () => useHasPermission("Customers.Create");
export const useCanEditCustomers = () => useHasPermission("Customers.Edit");

// QR codes + field-location tracking (handoff §19) - viewing a customer's
// QR code only needs Customers.View (any viewer), but the field-visit
// history/compare report and the admin locations map both need this
// separate, admin/manager-only permission. Customers.ScanQr (the Flutter
// scan flow) has no React-side hook - there's nothing to gate here, it's
// only ever checked server-side against the mobile app's calls.
export const useCanViewLocation = () => useHasPermission("Customers.ViewLocation");
